import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SearchTypeahead from 'web/components/SearchTypeahead';
import { BuyerCategories, SellerCategories } from './Categories'
import AlertModal from 'web/components/AlertModal';
import AdvanceSearch from 'web/components/AdvanceSearch';
import {  HeadingWrapper} from './DashBoardStyle';
import HomePalletImage from 'web/assets/images/dashboard-pallet-home-image.webp'
import { Container,  SearchSection, DashBoardWrapper, DashBoardHeading, BuyPallets, SellPallets, SellWrapper, BuyWrapper, LinkSection, CardExpiryBanner } from 'web/pages/private/CommonPages/DashBoard/DashBoardStyled'
import DashboardRightArrow from "web/assets/images/dashboard-right-arrow.png";
import DashboardRightArrowMobile from "web/assets/images/dashboard-right-arrow-mobile.png";
import DashboardGreyArrow from "web/assets/images/dashboard-grey-arrow.png";
import DashboardLeftGreyArrow from "web/assets/images/dashboard-greyLeft-arrow.png";
import DashboardLeftArrow from "web/assets/images/dashboard-left-arrow.png";
import DashboardLeftArrowMobile from "web/assets/images/dashboard-left-arrow-mobile.png";
import DashboardLeftGreyArrowMobile from "web/assets/images/dashboard-greyLeft-arrow-mobile.png";
import DashboardRightGreyArrowMobile from "web/assets/images/dashboard-greyRight-arrow-mobile.png";
import xIcon from 'web/assets/images/XIcon.png';
import AOS from 'aos';

import { fetchLanguageContentNew } from 'redux/actions/language';
import { toggleGuestUpgradeModal } from 'redux/actions/app';

const DashBoard = ({ title }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  let history = useHistory();
  let dispatch = useDispatch();
  let accountType = localStorage.getItem('accountType')
  let token = localStorage.getItem('token')

  const cardExpiryDetails = useSelector(state => state.authReducer.cardExpiryDetails)

  const [showCardExpiry, setShowCardExpiry] = useState(true)
  const [advanceModal, setAdvanceModal] = useState(false);
  const advanceModalToggleModal = () => setAdvanceModal(!advanceModal);
  const [pageTypeSet, setPageTypeSet] = useState('');

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);


  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    if (!token) {
      history.push('/sign-in')
      window.location.reload(false);
    }
  }, [token]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Dashboard_Page) setPageLanguageContents(languageContentNew.Dashboard_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const advanceSearchBuyerClick = () => {
    setPageTypeSet('PostInventory')
    advanceModalToggleModal()
  }

  const advanceSearchSellerClick = () => {
    setPageTypeSet('PostLoad')
    advanceModalToggleModal()
  }

  return (
    <>
      <Container data-aos="fade-up" data-aos-delay="200">
        {((cardExpiryDetails.buyerCardExpired || cardExpiryDetails.sellerCardExpired || cardExpiryDetails.subscriptionCardExpired) && showCardExpiry) &&
          <CardExpiryBanner>
            <p>
              <img src={xIcon} alt="X-Icon" onClick={() => setShowCardExpiry(false)} />
              {(cardExpiryDetails.buyerCardExpired && (cardExpiryDetails.sellerCardExpired || cardExpiryDetails.subscriptionCardExpired)) ? 'Buyer card, ' : cardExpiryDetails.buyerCardExpired && 'Buyer card '}
              {(cardExpiryDetails.sellerCardExpired && cardExpiryDetails.subscriptionCardExpired) ? 'Seller card, ' : cardExpiryDetails.sellerCardExpired && 'Seller card '}
              {cardExpiryDetails.subscriptionCardExpired && 'Subscription card '}
              has been expired. Please
              <span onClick={() => history.push('/manage-account?pageType=manageAccount')}>&nbsp;click here
              </span>
              &nbsp;to update.
            </p>
          </CardExpiryBanner>
        }

        <DashBoardWrapper>
          <DashBoardHeading >
            <h3>Welcome to A Revolutionary Online Marketplace for Buying & Selling Pallets</h3>
            {/* <h3>{pageLanguageContents?.Dashboard[0]?.Title}</h3>  */}
            {/* <h3>Welcome to The World’s First Online Marketplace for Buying & Selling Pallets</h3> */}
            {/* <p>
              {pageLanguageContents?.Dashboard[1]?.Description}
            </p> */}
          </DashBoardHeading>
            
         <SellWrapper >
            {(accountType === "Seller" ||
              accountType === "Both" ||
              accountType === "Reseller") ? <>
                <img
                  className="dashboard-left-arrow"
                  src={DashboardLeftArrow}
                  alt="DashboardLeftArrow"
                />
                <img
                  className="dashboard-left-arrow-mobile"
                  src={DashboardLeftArrowMobile}
                  alt="DashboardLeftArrowMobile"
                />
              </> : <>
                <img
                  className="dashboard-left-arrow"
                  src={DashboardLeftGreyArrow}
                  alt="DashboardLeftArrow"
                />
                <img
                  className="dashboard-left-arrow-mobile"
                  src={DashboardLeftGreyArrowMobile}
                  alt="DashboardLeftArrowMobile"
                />
              </>}
            <SellPallets>
              {/* {accountType === "Seller" ||
                accountType === "Both" ||
                accountType === "Reseller" ? ( */}
              <div className="text-wrapper">
              {accountType !== "Seller" && accountType !== "Both" && accountType !== "Reseller" && <div className={`overlay ${(localStorage.getItem('disableFlg') === 'true')? 'opacityDisable' : ''}`}></div>}
                <div className="triangle-wrapper">
                  <div className="sell-triangle"></div>
                  <h3>{pageLanguageContents?.Sell_Arrow[0]?.Title}</h3>
                </div>

                <p>{pageLanguageContents?.Sell_Arrow[1]?.Description}</p>
                <div disabled="disabled" className={(cardExpiryDetails.subscriptionCardExpired) && 'search-event'}>
                  <SearchSection>
                    <SearchTypeahead
                      placeholder={pageLanguageContents?.Sell_Arrow[2]?.Placeholder}
                      focusOnShow={false}
                      filterBy="title"
                      pageType="PostLoad"
                      disabled={true}
                      pageName="Dashboard"
                      containerStyle="makeSearch"
                      color="#62b5d9"
                      background="#0a1f30"
                    />
                  </SearchSection>

                  <SellerCategories
                    advanceSearchClick={advanceSearchSellerClick}
                    pageType="PostLoad"
                    contents={pageLanguageContents}
                  />
                </div>
                {accountType !== "Seller" && accountType !== "Both" && accountType !== "Reseller" && <LinkSection> 
                {accountType !== "Guest"? <Link to="/manage-account">
                  Click <span>here</span>
                  </Link> : <a href='#' onClick={() => {
                    dispatch(toggleGuestUpgradeModal(true))
                  }}>
                    Click <span>here</span>
                  </a>}
                
                <span style={{ 'margin-top': '6px' }}>&nbsp;to register as a seller</span>
                </LinkSection>}
              </div>
             
            </SellPallets>
          </SellWrapper>
          <BuyWrapper >
            <BuyPallets>
              <div className="text-wrapper">              
                {accountType !== "Guest" && accountType !== "Buyer" && accountType !== "Both" && accountType !== "Reseller" && <div className="overlay"> </div>}
                <div className="triangle-wrapper">
                  <h3>{pageLanguageContents?.Buy_Arrow[0]?.Title}</h3>
                </div>
                <p>{pageLanguageContents?.Buy_Arrow[1]?.Description}</p>
                <div className={(cardExpiryDetails.subscriptionCardExpired) && 'search-event'}>
                  <SearchSection>
                    <SearchTypeahead
                      placeholder={pageLanguageContents?.Buy_Arrow[2]?.Placeholder}
                      focusOnShow={false}
                      filterBy="title"
                      title={title}
                      pageType="PostInventory"
                      pageName="Dashboard"
                      containerStyle="makeSearch"
                      color="#074269"
                      backgroundColor="#01b3ff"
                    />
                  </SearchSection>

                  <BuyerCategories
                    advanceSearchClick={advanceSearchBuyerClick}
                    pageType="PostInventory"
                    contents={pageLanguageContents}
                  />
                </div>
                {accountType !== "Guest" && accountType !== "Buyer" && accountType !== "Both" && accountType !== "Reseller" && <LinkSection> <Link to="/manage-account">
                  Click <span>here</span>
                </Link><span style={{ 'margin-top': '6px' }}>&nbsp;to register as a buyer</span> </LinkSection>}
              </div>             
            </BuyPallets>
            {accountType === "Buyer" ||
              accountType === "Both" ||
              accountType === "Reseller" || accountType === "Guest" ? <><img
                className="dashboard-right-arrow"
                src={DashboardRightArrow}
                alt="DashboardRightArrow"
              />
                <img
                  className="dashboard-right-arrow-mobile"
                  src={DashboardRightArrowMobile}
                  alt="DashboardRightArrowMobile"
                />
              </> :
              <><img
                className="dashboard-right-arrow"
                src={DashboardGreyArrow}
                alt="DashboardRightArrow"
              />
                <img
                  className="dashboard-right-arrow-mobile"
                  src={DashboardRightGreyArrowMobile}
                  alt="DashboardRightArrowMobile"
                />
              </>
            }
          </BuyWrapper>
          
          <img
            className="pallet-image"
            src={HomePalletImage}
            alt="home-pallet-image"
          />
        </DashBoardWrapper>

        <HeadingWrapper>
        </HeadingWrapper>
      </Container>

      <AdvanceSearch
        isOpen={advanceModal}
        toggle={advanceModalToggleModal}
        title=""
        content=""
        link="/"
        pageType={pageTypeSet}
        callBackFun={(obj) => { }}
      />
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=""
        content=''
        link='/'
      />
    </>
  );
}



export default DashBoard;
